import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { BlogsRequestBody, BlogsResponse } from "./types";

export class BlogsAPI extends BaseAPI<
    BlogsRequestBody,
    BlogsResponse
> {
    protected route = ApiRoutes.blog.blog;
    protected method = RequestMethod.GET;
}
